export const UX_COPY_TH = {
  "quickNavAria": "ทางลัดไปยังส่วนต่าง ๆ ของหน้า",
  "skipToSections": "ข้ามไปยังเมนูของแต่ละส่วน",
  "jumpToStudioHint": "ทางลัด: Alt + S"
};

export const TRIAL_FLOW_COPY_TH = {
  "flowLabel": "ขั้นตอนต่อไป",
  "flowSteps": [
    "เลือกภาพหนึ่งภาพเพื่อทดลองแบบรวดเร็ว",
    "ระบบจะเปิด Metadata Studio พร้อมมาร์เก็ตเพลสที่คุณเลือก",
    "ตรวจทานและแก้ไขผลลัพธ์ก่อนส่งออก"
  ]
};

export const LANDING_SALES_COPY_TH = {};


export default LANDING_SALES_COPY_TH;
